"use client"

import type React from "react"

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

import type { NewItemDialogState } from "../../file-tree-manager/types/tree-types"

interface NewItemDialogProps {
  dialog: NewItemDialogState
  itemName: string
  onClose: () => void
  onNameChange: (name: string) => void
  onCreate: () => void
}

export const NewItemDialog: React.FC<NewItemDialogProps> = ({ dialog, itemName, onClose, onNameChange, onCreate }) => {
  return (
    <Dialog open={dialog.open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>새 {dialog.type === "folder" ? "부서" : "컨텐츠"} 만들기</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label={`${dialog.type === "folder" ? "부서" : "컨텐츠"} 이름`}
          fullWidth
          variant="outlined"
          value={itemName}
          onChange={(e) => onNameChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") onCreate()
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>취소</Button>
        <Button onClick={onCreate} variant="contained" disabled={!itemName.trim()}>
          만들기
        </Button>
      </DialogActions>
    </Dialog>
  )
}


